import IconResults from "@/components/svg/IconResults.vue";
import IconSales from "@/components/svg/IconSales.vue";
import IconCosts from "@/components/svg/IconCosts.vue";
import IconProfitability from "@/components/svg/IconProfitability.vue";
import IconNoOper from "@/components/svg/IconNoOper.vue";
import IconAssets from "@/components/svg/IconAssets.vue";

// Identificadores canónicos de los tabs del DashboardReports.
// Estos strings aparecen en (a) el v-if/v-else-if del padre, (b) los items
// de NavigationTabs, y (c) los `data-theme="X"` de cada tab hijo. Centralizar
// acá evita typos silenciosos entre los 3 lugares.
export const TAB_IDS = Object.freeze({
    RESULTADOS: "resultados",
    VENTAS: "ventas",
    COSTOS: "costos",
    GASTOS: "gastos",
    RENTABILIDAD: "rentabilidad",
    NO_OPER: "no_oper",
    ACTIVOS: "activos",
    KPIS: "kpis",
    PROYECCIONES: "proyecciones",
});

// Configuración consumida por NavigationTabs. Cada `icon` es el componente
// SFC importado directamente (no un string), así <component :is="tab.icon" />
// resuelve sin necesidad de registrarlo en el consumer. ESLint
// (vue/no-unused-components) no puede inferir uso dinámico por nombre, este
// patrón evita ese falso positivo.
export const TABS_CONFIG = Object.freeze([
    { id: TAB_IDS.RESULTADOS, label: "Resultados", icon: IconResults },
    { id: TAB_IDS.VENTAS, label: "Ventas", icon: IconSales },
    { id: TAB_IDS.COSTOS, label: "Costos", icon: IconCosts },
    // Costos y Gastos comparten el mismo icono (era así en el original).
    { id: TAB_IDS.GASTOS, label: "Gastos", icon: IconCosts },
    { id: TAB_IDS.RENTABILIDAD, label: "Rentabilidad", icon: IconProfitability },
    { id: TAB_IDS.NO_OPER, label: "No Oper", icon: IconNoOper },
    { id: TAB_IDS.ACTIVOS, label: "Activos", icon: IconAssets },
    { id: TAB_IDS.KPIS, label: "KPIs", icon: IconProfitability },
    { id: TAB_IDS.PROYECCIONES, label: "Proyecciones", icon: IconResults },
]);
